<!-- Zweck: Stellt die HTML-Struktur für app clock component im Frontend bereit. -->
@if (show|async) {
  <div class="clock clockposition_{{position}}" [innerHTML]="(dateTimeString|async)|raw">
  </div>
}
